import React,{useState} from 'react'
import Footer from '../Footer/Footer'
import Navbar from '../Navbar/Navbar'

const LoginUser = () => {
    const [inputData, setInputData] = useState({
        email:'',
        password:''
    });
    const data=(e)=>{
        const {name,value}=e.target;
        setInputData({...inputData,[name]:value})

    }
    const submitData=(e)=>{
        e.preventDefault();
        const{email,password}=inputData;
        if(!email||!password){
            alert('Please Enter Details');
        }
        console.log(email,password);
        setInputData({email:'',password:''});
    }
    
  return (
    <>
    <Navbar/>
        <div className="content-spacing content-spacing-tb user-rigiter">
            <input type="email" placeholder='Enter Your Email' required name='email' value={inputData.email} onChange={data} />
            <input type="password" placeholder='Enter Your Password' required  name='password' value={inputData.password} onChange={data}/>
            <button type='submit' onClick={submitData}>Submit</button>
        </div>
        <Footer/>
    </>
  )
}

export default LoginUser